import { Pipe, PipeTransform } from '@angular/core';
import { AddressModel } from '../../models';

@Pipe({
    name: 'filterSimilarAddress',
    standalone: false
})
export class UliSimilarAddressPipe implements PipeTransform {
  transform(addresses: AddressModel[], controlValue: AddressModel): AddressModel[] {
    return controlValue
      ? addresses?.filter((address: AddressModel) => address.addressExtId !== controlValue.addressExtId)
      : addresses;
  }
}
